import {
  Badge,
  BadgeProps,
  Icon,
  useThemedValueSwitch,
  VisuallyHidden,
} from '@tq/ui-components';
import React from 'react';

import { useConsultationStatuses } from './hooks';
import { Consultation, ConsultationCard } from 'types';
import { isOverdue, isNearingDeadline } from '../../tools';

export interface StatusIndicatorProps extends BadgeProps {
  consultation: Consultation | ConsultationCard | undefined;
  screenReaderLabel?: string;
}

export const ConsultationStatusIndicator: React.FC<StatusIndicatorProps> = ({
  consultation,
  screenReaderLabel,
  ...parentBadgeProps
}) => {
  const { isTQ } = useThemedValueSwitch();
  let status = isOverdue(consultation) ? 'Overdue' : consultation?.status ?? 'New';

  if (isNearingDeadline(consultation) && consultation?.status === 'Active')
    status = 'Active isNearingDeadline';

  const { label, badgeProps, icon } = useConsultationStatuses(isTQ)[status];

  return (
    <>
      <Badge
        display='flex'
        alignItems='center'
        justifyContent='center'
        fontSize='sm'
        mr={0}
        aria-hidden={Boolean(screenReaderLabel)}
        {...badgeProps}
        {...parentBadgeProps}
      >
        {label}
        {icon && <Icon ml={2} as={icon} />}
      </Badge>
      {screenReaderLabel ? <VisuallyHidden>{screenReaderLabel}</VisuallyHidden> : null}
    </>
  );
};
